<template>
  <div class="content">
    <div class="container-fluid mt-7">
      <div class="card pb-2">
        <div :class="['card-pricing bg-white border-0 mb-4', cardClass]">
          <div :class="['pt-4 pb-3 d-flex align-items-center card-header', headerClass]">
            <h3 class="mb-0">{{ header }}</h3>
          </div>
          <div class="px-4 py-3">
            <div v-if="Object.keys(portfolioConfigs).length" v-for="(config, portfolio) in portfolioConfigs"
              :key="portfolio" class="card mb-4 shadow-sm">
              <div class="card-header bg-entry">
                <h4 class="mb-0"> {{ portfolioLabels[portfolio] || toHeaderCase(portfolio) }}</h4>
              </div>
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <td width="35%"><b>Profit Levels</b></td>
                    <td width="45%">
                      {{ config.profitLevels.join(",") }}
                    </td>
                    <td width="20%" class="text-center">
                      <base-button :class="buttonClass" size="sm" @click="openEditModal(
                        portfolio,
                        'profitLevels',
                        portfolio + '_PROFIT_PERCENTAGE_LEVEL',
                        config.profitLevels.join(',')
                      )">
                        Edit
                      </base-button>
                    </td>
                  </tr>
                  <tr>
                    <td><b>Loss Levels</b></td>
                    <td>
                      {{ config.lossLevels.join(",") }}
                    </td>
                    <td class="text-center">
                      <base-button :class="buttonClass" size="sm" @click="openEditModal(
                        portfolio,
                        'lossLevels',
                        portfolio + '_LOSS_PERCENTAGE_LEVEL',
                        config.lossLevels.join(',')
                      )">
                        Edit
                      </base-button>
                    </td>
                  </tr>
                  <tr>
                    <td><b>Exit Start Time</b></td>
                    <td>{{ config.exitStartTime }}</td>
                    <td class="text-center">
                      <base-button :class="buttonClass" size="sm" @click="openEditModal(
                        portfolio,
                        'exitStartTime',
                        portfolio + '_PF_EXIT_START_TIME',
                        config.exitStartTime
                      )">
                        Edit
                      </base-button>
                    </td>
                  </tr>
                  <tr>
                    <td><b>Exit End Time</b></td>
                    <td>{{ config.exitEndTime }}</td>
                    <td class="text-center">
                      <base-button :class="buttonClass" size="sm" @click="openEditModal(
                        portfolio,
                        'exitEndTime',
                        portfolio + '_PF_EXIT_END_TIME',
                        config.exitEndTime
                      )">
                        Edit
                      </base-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center text-muted py-5">
              No Data Available
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade show d-block" tabindex="-1" v-if="showModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Edit Variable
            </h5>
            <button type="button" class="close" @click="closeModal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Variable</label>
              <input class="form-control" disabled :value="toHeaderCase(modalData.name)">
            </div>
            <div class="form-group">
              <label>Value</label>
              <input type="text" class="form-control" v-model="modalData.value" placeholder="Example: 1,2,3 or 09:30">
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="closeModal">
              Close
            </button>
            <button class="btn btn-primary" @click="updateVariable">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SystemVariableCard",
  props: {
    cardClass: {
      type: String,
      default: ""
    },
    headerClass: {
      type: String,
      default: ""
    },
    buttonClass: {
      type: String,
      default: ""
    },
    header: {
      type: String,
      default: "System Variables"
    }
  },
  data() {
    return {
      portfolioLabels: {
        IDX_OPT: "INDEX OPTION",
        COM_OPT: "COMMODITY OPTION",
        COM_FUT: "COMMODITY FUTURE"
      },
      portfolioConfigs: {},
      showModal: false,
      modalData: {
        portfolio: "",
        field: "",
        name: "",
        value: ""
      }
    };
  },
  mounted() {
    this.getVariables();
  },
  methods: {
    getVariables() {
      this.$store.dispatch(
        "variableStore/getVariableDetails",
        null,
        { root: true }
      )
        .then(response => {
          this.portfolioConfigs = response.server.data || {};
        })
        .catch(console.log);
    },
    toHeaderCase(value) {
      if (!value) return "";
      return value
        .replace(/_/g, " ")
        .replace(/\b\w/g, c => c.toUpperCase());
    },
    openEditModal(portfolio, field, name, value) {
      this.modalData = {
        portfolio,
        field,
        name,
        value
      };
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    updateVariable() {
      const data = {
        variableName: this.modalData.name,
        value: this.modalData.value
      };
      this.$store.dispatch(
        "variableStore/updateVariables",
        data,
        { root: true }
      )
        .then(() => {
          if (
            this.modalData.field === "profitLevels" ||
            this.modalData.field === "lossLevels"
          ) {
            this.portfolioConfigs[this.modalData.portfolio][this.modalData.field] =
              this.modalData.value
                .split(",")
                .map(Number);
          } else {
            this.portfolioConfigs[this.modalData.portfolio][this.modalData.field] =
              this.modalData.value;
          }
          this.closeModal();
        })
        .catch(console.log);
    }
  }
};
</script>
<style scoped></style>
